import React from 'react'
import ArrowLink from './ArrowLink'
import TransactionDetails from './TransactionDetails'
import MessageNotification from './MessageNotification'
import TransactionCard from './TransactionCard'
import FloatingIcon from './FloatingIcon'
import HelpSection from './HelpSection'
import ActionButton from './ActionButton'


function Milieu() {
  return (    
    <div >
        <ArrowLink/>
        <TransactionDetails />
        <MessageNotification/>     
        <TransactionCard/>   
        <FloatingIcon/>
        <HelpSection/>
        <ActionButton/>
    </div>    
  )
}

export default Milieu